import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import contentfolder from "../../../contentImgs/folder.png";
import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import ContentFolderCard from "../ContentFolderCard";
import Toggle from "../../../UI/Toggle";
import FolderForQuiz from "./FolderForQuiz";
import { createNewMockTest, getQuizDataByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuizSetUpOuter from "./QuizSetUpOuter";
import HighlightsQuiz from "./HighlightsQuiz";
import FAQsQuiz from "./FAQsQuiz";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const LanguageAndLabelsQuiz= ({quizObjectID,setQuizObjectDataBack})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
      const [goNextPopUp, setGoNextPopUp] =useState(false);
     
     const [activeStep, setActiveStep] = useState(0);
     const [activeSubStepOne, setActiveSubStepOne] = useState(3);
     
     const [activeSubStepTwo, setActiveSubStepTwo] = useState(0);
     const [activeSubStepThree, setActiveSubStepThree] = useState(0);
     const [activeSubStepFour, setActiveSubStepFour] = useState(0);
     const [activeSubStepFive, setActiveSubStepFive] = useState(0);
     const [titleActive, setTitleActive] = useState(true);
     const [desctiptionActive, setDesctiptionActive] = useState(false);
     const [highlightActive, setHighlightActive] = useState(false);
     const [FAQActive, setFAQActive] = useState(false); 
     const [selectedNameId , setSelectedNameId] =useState(null)
     const [selectedNameDiffLevelId , setSelectedNameDiffLevelId] =useState(null)
     const [selectedNameTestStatusId , setSelectedNameTestStatusId] =useState(null)
      
     const [languageNames, setLanguageNames] = useState(
     [
      {
          "ID": "4",
          "post_title": "English"
      },
      {
          "ID": "5",
          "post_title": "हिंदी"
      },
      {
          "ID": "6",
          "post_title": "বাংলা"
      },
      {
          "ID": "7",
          "post_title": "తెలుగు"
      },
      {
          "ID": "8",
          "post_title": "मराठी"
      },
      {
          "ID": "9",
          "post_title": "தமிழ்"
      },
      {
          "ID": "10",
          "post_title": "ગુજરાતી"
      },
      {
          "ID": "11",
          "post_title": "Urdu"
      },
      {
          "ID": "12",
          "post_title": "ಕನ್ನಡ"
      },
      {
          "ID": "13",
          "post_title": "മലയാളം"
      },
      {
          "ID": "14",
          "post_title": "ଓଡ଼ିଆ"
      },
      {
          "ID": "15",
          "post_title": "ਪੰਜਾਬੀ"
      },
      {
          "ID": "16",
          "post_title": "অসমীয়া"
      },
      {
          "ID": "17",
          "post_title": "मैथिली"
      },
      {
          "ID": "18",
          "post_title": "ᱥᱟᱱᱛᱟᱲᱤ"
      },
      {
          "ID": "19",
          "post_title": "Koshur"
      },
      {
          "ID": "20",
          "post_title": "नेपाली"
      },
      {
          "ID": "21",
          "post_title": "Sindhi"
      }
  ]);

  
  const [difficultyLevelNames, setDifficultyLevelNames] = useState([
    {
        "ID": "1",
        "post_title": "Basic"
    },
    {
        "ID": "2",
        "post_title": "Intermediate"
    },
    {
        "ID": "3",
        "post_title": "Advanced"
    }
])
const [testStatusNames, setTestStatusNames]=useState([
  {
      "ID": "1",
      "post_title": "Trending"
  },
  {
      "ID": "2",
      "post_title": "Recently Started"
  },
  {
      "ID": "3",
      "post_title": "Coming Soon"
  },
  {
      "ID": "4",
      "post_title": "Archieved"
  }
])
const defaultTitles = [
  'English',
  'हिंदी',
  'বাংলা',
  'తెలుగు',
  'मराठी',
  'தமிழ்',
  'ગુજરાતી',
  'Urdu',
  'ಕನ್ನಡ',
  'മലയാളം',
  'ଓଡ଼ିଆ',
  'ਪੰਜਾਬੀ',
  'অসমীয়া',
  'मैथिली',
  'ᱥᱟᱱᱛᱟᱲᱤ', // Santali
  'Koshur',       // Kashmiri
  'नेपाली',
  'Sindhi'
];
  
const defaultTitlesDifflevel = ['Basic', 'Intermediate', 'Advanced'];
const defaultTitlesTestStatus = ['Trending', 'Recently Started', 'Coming Soon', 'Archieved'];

    const steps = ([{number:1,name:"Language"},{number:2,name:"Difficulty Level"},{number:3,name:"Test Status"}]);
    const subSteps = [1, 2, 3, 4, 5];
    const subStepOneTotal= 3;
    const subStepTwoTotal= 3;
    const subStepThreeTotal= 3;
    const subStepFourTotal= 3;
    const subStepFiveTotal= 3;
    ;
        const [sellAsTestSeries, setSellAsTestSeries] = useState(false);
   
        const [folderForQuizPopUp, setFolderForQuizPopUp] = useState(false);
        const [folderForQuizPopUpCreateFolder, setFolderForQuizPopUpCreateFolder] = useState(false);
        const [parentFolder, setParentFolder] = useState({ID:""});
        
        
        const [quizName, setQuizName] = useState("");
        const [quizDescription,  setQuizDescription] = useState("");
        const [higlights,  setHiglights] = useState([]);
        const [FAQs,  setFAQs] = useState([]);
        
        const [quizID, setQuizID] = useState("");
        const [quizObject, setQuizObject] = useState({});
   
    const userdata = useSelector((state)=>state?.user?.user);
   useEffect(()=>{
   
   fireGetQuizDataByQuizId()
   
   },[])
   useEffect(()=>{
   
    setAnimate(false);  
    const timer = setTimeout(() => {
     setAnimate(true);  
   }, 1000);
 
    return () => clearTimeout(timer); 
    },[titleActive,desctiptionActive,highlightActive,FAQActive])
   const fireGetQuizDataByQuizId=()=>{
   
    setLoader({status:true});
    
      const apiData = dispatch(getQuizDataByQuizId({testName:quizName,type:"mock",
        postParent:"",userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObjectID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
          if(response?.quiz){
            
        setResponseMessage(response?.message);
        setSnackbarColor("rgba(144, 202, 249,1)");
      setQuizObject(response?.quiz)
      setSelectedNameId(response?.quiz?.testLanguage?JSON.parse(response?.quiz?.testLanguage)?.ID:"")
      setSelectedNameDiffLevelId(response?.quiz?.difficultyLevel?JSON.parse(response?.quiz?.difficultyLevel)?.ID:"")
      setSelectedNameTestStatusId(response?.quiz?.testStatus?JSON.parse(response?.quiz?.testStatus)?.ID:"")
    
    
    
      setLoader({status:false});
    
  
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }
     const handleCreateNewMockTest=(editType,val)=>{
     let SendObject=""
     if(editType=="testLanguage"){
        SendObject={testLanguage:JSON.stringify(val),type:"mock",
            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
             if(editType=="difficultyLevel"){
                SendObject={difficultyLevel:JSON.stringify(val),type:"mock",
                    postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                    currentToken:currentToken?currentToken:"",
                    editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                     }
                     if(editType=="testStatus"){
                        SendObject={testStatus:JSON.stringify(val),type:"mock",
                            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                            currentToken:currentToken?currentToken:"",
                            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                             }
                             
                     
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTest(SendObject));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){   
           if(response?.quiz){
             
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
       setQuizObject(response?.quiz)
          setSelectedNameId(response?.quiz?.testLanguage?JSON.parse(response?.quiz?.testLanguage)?.ID:"")
          setSelectedNameDiffLevelId(response?.quiz?.difficultyLevel?JSON.parse(response?.quiz?.difficultyLevel)?.ID:"")
          setSelectedNameTestStatusId(response?.quiz?.testStatus?JSON.parse(response?.quiz?.testStatus)?.ID:"")
    
       setHiglights( response?.quiz?.higlights?JSON.parse(response?.quiz?.higlights):[])
       setFAQs( response?.quiz?.FAQs?JSON.parse(response?.quiz?.FAQs):[])
    
       setQuizObjectDataBack(response?.quiz)
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
       if(editType=="testLanguage"){
        setQuizName(response?.quiz?.testName); setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
        setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0); }
        if(editType=="difficultyLevel"){
      
            setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
         
            } 
        
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
       
       const flattenedData =  languageNames&& languageNames!=[]?Object.values(languageNames):'';

       return <>
       
   
 
   {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}  
       <div   className=" progress-bar-container "style={{position:"relative",zIndex:"99"}}> 
   <div className="progress-bark">
        {steps?.map((step) => (<div className="animCirclek"  onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
        if(step?.number==1){ setTitleActive(true);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(0); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==2){  setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==3){  setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
          }else if(step?.number==4){  setTitleActive(false);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(true);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
          }
        }} style={{position:"relative"}} key={step?.number}>
          <div
            
            className={`circlek ${step?.number <= activeStep ? "activek" : ""}` }
            style={{background: `${step?.number ===1?
              `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                step?.number ===2?
                                                `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                step?.number ===3?
                                                `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                :step?.number ===4?
                                                `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                step?.number ===5?
                                                `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
            `}} 
          ><div   className={`circlekInn `}>
             {step?.number}
          </div>
          <div align="center" style={{width:"110px",position:"absolute",top:"55px",fontSize:"14px"}}>{step?.name}</div>
          </div></div>
        ))}<div style={{width:"95%",height:"5px",background:"rgb(86, 82, 131)",position:"absolute",left:"0px",top:"25px",right:"0px"}}></div>
      </div>  
    
      </div>
      <div  className=""style={{marginTop:"40px"}}><div  className=" " style={{overflowY:"auto",overflowX:"hidden",background:"#fff",borderRadius:"25px",paddingBottom:"50px"}}>

 {titleActive?
    <div>
<div  className="ikcraft_login-input-card">
<h2 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-20px)',
     opacity: animate ? 1 : 0.5,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Set Test  <span className="coloredTextV1" >Language </span></h2>
   
   <div class="input-card-outer" >
                                 
                                 <div class="input-card-radio-two" style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-20px)',
     opacity: animate ? 1 : 0.5,
     transition: 'transform 1s ease',
   }}>
                                 {languageNames?.map((item, index) => 
        (<div className= {defaultTitles.includes(item?.post_title)?"input-card-radio-two-item-default":"input-card-radio-two-item"}  index={index} key={item.id} 
        style={{background:"#f9f9f9",borderRadius:"25px",padding:"5px"}} >  <label onMouseEnter={
            ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave} className={"boxCard-outer"}  style={{
  transform: animate ? 'scale(1)' : `scale(0.6)`,
  opacity: animate ? 1 : `0.5`,
  transition: `transform 0.${5*index}s ease`}}>
                    
                       <div >{item?.post_title}</div> 
                    
                             <input type="radio" title={item?.post_title}  
checked={selectedNameId==item?.ID?"yes":""} 
                              className="input-textbox"  value={item?.ID}  name={item?.post_title}  
onChange={e=>{
    handleCreateNewMockTest("testLanguage",item)
    setSelectedNameId(e.target.value)
}

}

onClick={e=>{
  handleCreateNewMockTest("testLanguage",item)
setSelectedNameId(e.target.value)

}

}
/>
                                <span class={"boxCardBorder"}></span>
                       </label>
                      
                     
                       </div>))
        } 
                         
 </div>
 
 
  </div> 
 

 </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
    <div  >   </div>
  
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"5px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><div></div>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{  setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
    setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0); }
}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":" Next"} </button>
</div>
</div> </div>:""}
 
{desctiptionActive?
   <div>
    <div  className="ikcraft_login-input-card">
    <h2 style={{"textAlign":"center",
         transform: animate ? 'translateY(0)' : 'translateY(-20px)',
         opacity: animate ? 1 : 0.5,
         transition: 'transform 1s ease, opacity 1s ease',
       }}> Define Test  <span className="coloredTextV1" > Difficulty Level </span></h2>
       
       <div class="input-card-outer" >
                                     
                                     <div class="input-card-radio-two" style={{"textAlign":"center",
         transform: animate ? 'translateY(0)' : 'translateY(-20px)',
         opacity: animate ? 1 : 0.5,
         transition: 'transform 1s ease',
       }}>
                                     {difficultyLevelNames?.map((item, index) => 
            (<div className= {defaultTitlesDifflevel.includes(item?.post_title)?"input-card-radio-two-item-default":"input-card-radio-two-item"}  index={index} key={item.ID} 
            style={{background:"#f9f9f9",borderRadius:"25px",padding:"5px"}} >  <label onMouseEnter={
                ()=>handleMouseEnter("#fff","#333","","")}
    onMouseLeave={handleMouseLeave} className={"boxCard-outer"}  style={{
      transform: animate ? 'scale(1)' : `scale(0.6)`,
      opacity: animate ? 1 : `0.5`,
      transition: `transform 0.${5*index}s ease`}}>
                        
                           <div >{item?.post_title}</div> 
                        
                                 <input type="radio" title={item?.post_title}  
    checked={selectedNameDiffLevelId==item?.ID?"yes":""} 
                                  className="input-textbox"  value={item?.ID}  name={item?.post_title}  
    onChange={e=>{
        handleCreateNewMockTest("difficultyLevel",item)
        setSelectedNameDiffLevelId(e.target.value)
    }
    
    }
    
    onClick={e=>{
      handleCreateNewMockTest("difficultyLevel",item)
      setSelectedNameDiffLevelId(e.target.value)
    
    }
    
    }
    />
                                    <span class={"boxCardBorder"}></span>
                           </label>
                          
                         
                           </div>))
            } 
                             
     </div>
     
     
      </div> 
     
    
     </div>
     <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
        <div  >   </div>
      
        <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"5px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}><div></div><button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{setTitleActive(true);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(false);
       setActiveSubStepOne(3);   setActiveSubStepTwo(0); setActiveSubStepThree(0); setActiveSubStepFour(0);}}   className=" CoursesPreviewTopBtn"  type="submit"
    > Back </button>
    <button onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} onClick={()=>{   setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
        setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
     }
    }  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
      className=" CoursesPreviewTopBtn"  type="submit"
     > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":" Next"} </button>
    </div>
    </div> </div>
 :""}

{highlightActive?  <div>
    <div  className="ikcraft_login-input-card">
    <h2 style={{"textAlign":"center",
         transform: animate ? 'translateY(0)' : 'translateY(-20px)',
         opacity: animate ? 1 : 0.5,
         transition: 'transform 1s ease, opacity 1s ease',
       }}> Highlight  <span className="coloredTextV1" > Test Status </span></h2>
       
       <div class="input-card-outer" >
                                     
                                     <div class="input-card-radio-two" style={{"textAlign":"center",
         transform: animate ? 'translateY(0)' : 'translateY(-20px)',
         opacity: animate ? 1 : 0.5,
         transition: 'transform 1s ease',
       }}>
                                     {testStatusNames?.map((item, index) => 
            (<div className= {defaultTitlesTestStatus.includes(item?.post_title)?"input-card-radio-two-item-default":"input-card-radio-two-item"}  index={index} key={item.ID} 
            style={{background:"#f9f9f9",borderRadius:"25px",padding:"5px"}} >  <label onMouseEnter={
                ()=>handleMouseEnter("#fff","#333","","")}
    onMouseLeave={handleMouseLeave} className={"boxCard-outer"}  style={{
      transform: animate ? 'scale(1)' : `scale(0.6)`,
      opacity: animate ? 1 : `0.5`,
      transition: `transform 0.${5*index}s ease`}}>
                        
                           <div >{item?.post_title}</div> 
                        
                                 <input type="radio" title={item?.post_title}  
    checked={selectedNameTestStatusId==item?.ID?"yes":""} 
                                  className="input-textbox"  value={item?.ID}  name={item?.post_title}  
    onChange={e=>{
        handleCreateNewMockTest("testStatus",item)
        setSelectedNameTestStatusId(e.target.value)
    }
    
    }
    
    onClick={e=>{
      handleCreateNewMockTest("testStatus",item)
      setSelectedNameTestStatusId(e.target.value)
    
    }
    
    }
    />
                                    <span class={"boxCardBorder"}></span>
                           </label>
                          
                         
                           </div>))
            } 
                             
     </div>
     
     
      </div> 
     
    
     </div>
     <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
        <div  >   </div>
      
        <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"5px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}><div></div><button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{ setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
      setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
  ;}}   className=" CoursesPreviewTopBtn"  type="submit"
    > Back </button>
    <button onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} onClick={()=>{   setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
        setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
     }
    }  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
      className=" CoursesPreviewTopBtn"  type="submit"
     > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":" Next"} </button>
    </div>
    </div> </div>
 :""} 
    
 <div>
     </div>
    
    </div>
    </div>
     </>


}
export default LanguageAndLabelsQuiz;